import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Channel } from '@typings/channel';

type InitialState = {
  byId: Record<string, Channel>;
};

export const initialState: InitialState = {
  byId: {},
};

export const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    setChannelDataById: (state, action: PayloadAction<Channel>) => {
      const oldChannelData = state.byId[action.payload.id] || {};
      state.byId[action.payload.id] = { ...oldChannelData, ...action.payload };
    },
    setChannelsData: (state, action: PayloadAction<Channel[]>) => {
      action.payload.forEach((channel) => {
        const previousData = state.byId[channel.id] || {};
        state.byId[channel.id] = { ...previousData, ...channel };
      });
    },
  },
});

export const { setChannelDataById, setChannelsData } = channelsSlice.actions;

export default channelsSlice.reducer;
